import React from 'react'

const LogOut = () => {

    return (
        <div>

        </div>
    )
}

export default LogOut
